module.exports = __webpack_public_path__ + "img/vip-coupon.82c18961.png";